$bog_wikilive_app $mol_book2
	plugins /
		<= Theme $mol_theme_auto
	pages /
		<= Nav $bog_ui_sidebar
			mode? <=> sidebar_mode? \dock
			Header <= Nav_header $mol_view
				sub /
					<= Logo $bog_wikilive_logo
			items /
				<= Home_nav $bog_ui_sidebar_item
					Icon <= Home_icon $mol_icon_home
					label \Главная
					active <= home_active false
					click? <=> nav_home? null
				<= Search_nav $bog_ui_sidebar_item
					Icon <= Search_icon $mol_icon_magnify
					label \Поиск
					active <= search_active false
					click? <=> nav_search? null
				<= Tree
				<= Profile_nav $bog_ui_sidebar_item
					Icon <= Profile_icon $mol_icon_account
					label \Профиль
					active <= profile_active false
					click? <=> nav_profile? null
			Footer <= Nav_footer $mol_view
				sub /
					<= Add_menu $mol_pop
						showed? <=> add_menu_showed? false
						Anchor <= Add_page $mol_button_minor
							title \+ Страница
							click? <=> add_menu_toggle? null
						bubble_content /
							<= Add_blank $mol_button_minor
								title \Пустая
								click? <=> page_create_blank? null
							<= Add_meeting $mol_button_minor
								title \Протокол встречи
								click? <=> page_create_meeting? null
							<= Add_spec $mol_button_minor
								title \Спецификация
								click? <=> page_create_spec? null
							<= Add_guide $mol_button_minor
								title \Руководство
								click? <=> page_create_guide? null
					<= Lighter $mol_lights_toggle
		<= Content $mol_view
			sub <= content_pages /
	Tree $bog_wikilive_tree
		store <= store
		page_selected? <=> page_selected? \
	Page $bog_wikilive_page
		store <= store
		page_link <= page_selected? \
	Welcome $mol_page
		title \WikiLive
		body /
			<= Welcome_text $mol_text
				text \
					\# Добро пожаловать в WikiLive
					\
					\Выберите страницу в дереве слева или создайте новую.
	Profile $bog_wikilive_profile_page
		store <= store
		page_selected? <=> page_selected? \
	Search $bog_wikilive_search
		store <= store
		page_selected? <=> page_selected? \
	store $bog_wikilive_store
	screen? \home
